import * as React from "react";
import IntlMessage from '../../util/IntlMessage';

export const isNumber = (value: string) => {
    const numeric = Number(value);
    return numeric || numeric === 0 ? undefined : <IntlMessage id='common.validation.incorrect_number'/>;
};